import axios from "axios";

const API_BASE = process.env.REACT_APP_BASE_URL;


export interface ProjectCategory {
  id: number;
  name: string;
  description?: string;
  coverImageUrl?: string;
}

export const ProjectService = {
  async getCategories(): Promise<ProjectCategory[]> {
    const res = await axios.get(`${API_BASE}/categories`, { withCredentials: true });
    return res.data;
  },
};
